import LoadingButton from 'components/LoadingButton'
import styles from './style.css'
import {Field, reduxForm} from 'redux-form'
import ResetPasswordField from 'components/Fields/ResetPasswordField/ResetPasswordField'

const validate = values => {
  const errors = {}

  if (!values.newPassword) {
    errors.newPassword = 'The password is required'
  } else if (values.newPassword.length < 6) {
    errors.newPassword = 'Password at least have to be 6 characters long'
  }
  if (!values.confPassword) {
    errors.confPassword = 'The password is required'
  } else if (values.newPassword !== values.confPassword) {
    errors.confPassword = 'The password and its confirm are not the same'
  }
  return errors
}

let ResetPasswordForm = class ResetPasswordForm extends React.Component {
  render () {
    let {handleSubmit} = this.props
    let userFullName = this.props.fullName
    return (
      <div className='col-md-12 no-padding'>
        <form onSubmit={handleSubmit}>
          <p className={styles['description-reset-password']}>
            Hello {userFullName}. Please create a new password that is at least 6 characters long.
          </p>
          <Field
            component={ResetPasswordField}
            name='newPassword'
            type='password'
            placeholder='New Password'
            autoCorrect='off'
            maxLength='40'
            autoCapitalize='off'
            spellCheck='false'
          />
          <Field
            component={ResetPasswordField}
            name='confPassword'
            type='password'
            placeholder='Confirm New Password'
            autoCorrect='off'
            maxLength='40'
            autoCapitalize='off'
            spellCheck='false'
          />
          <div className={styles['submit-btn-container']}>
            {this.props.currentlySending ? (
              <LoadingButton />
          ) : (
            <button type='submit' className={'btn btn-primary center ' + styles['submit-btn']}>
              {this.props.btnText}
            </button>
             )}
          </div>
        </form>
      </div>
    )
  }
}

ResetPasswordForm.propTypes = {
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  btnText: React.PropTypes.string
}

const mapFormValidation = {
  form: 'ResetPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

export default reduxForm(mapFormValidation)(ResetPasswordForm)



// WEBPACK FOOTER //
// ./app/pages/ResetPassword/ResetPasswordForm.js